import gql from 'graphql-tag';

export const getExamsRoleByStudent = gql`
  query examsRoleQuery($period: String!, $career: String!) {
    examsRole {
      examsRoleByStudent(period: $period, career: $career) {
        examsFinals {
          id
          date
          courses {
            id
            name
            start
            end
            urlExamClass
            location {
              classroom
              campus
            }
            about
            modality
            isDisabled
          }
        }
        examsLagging {
          id
          date
          courses {
            id
            name
            start
            end
            urlExamClass
            location {
              classroom
              campus
            }
            about
            modality
            isDisabled
          }
        }
        examsReturn {
          id
          date
          courses {
            id
            name
            start
            end
            urlExamClass
            location {
              classroom
              campus
            }
            about
            modality
            isDisabled
          }
        }
      }
    }
  }
`;
